import type { CardProps } from '@mui/material';
import React from 'react';
import { MediaCardRoot } from './MediaCard.styles';

export {
  MediaCardContent,
  MediaCardThumbnail,
  MediaCardPreviewFrame,
  MediaCardContactFrame,
  MediaCardActions,
  MediaCardName,
  MediaCardEditIcon,
  MediaCardInlineEdit,
  MediaCardInlineInput,
  MediaCardInlineAction,
} from './MediaCard.styles';

export type MediaCardProps = CardProps & { cardHeight: number; selected?: boolean };

export const MediaCard = (props: MediaCardProps) => <MediaCardRoot {...props} />;
